import {DEFAULT_SCREEN, MEDIA_QUERY} from 'consts'
import {useEffect, useState} from 'react'
import {Screen} from 'types/basic'

export const useScreen = () => {
  const [screen, setScreen] = useState<Screen>(DEFAULT_SCREEN)

  useEffect(() => {
    const listener = (event: MediaQueryListEvent) => {
      setScreen(event.matches ? 'desktop' : 'mobile')
    }

    const mediaQueryList = window.matchMedia(MEDIA_QUERY)

    mediaQueryList.addEventListener('change', listener)

    return () => mediaQueryList.removeEventListener('change', listener)
  }, [])

  return screen
}
